<template>
  <div>
    <b-row class="my-1">
      <b-col sm="3">
        <label>Название чата:</label>
      </b-col>
      <b-col sm="9">
        <b-form-input v-model="name" type="text" />
      </b-col>
    </b-row>
      <div class="text-center mt-3"><b-button  variant="success" @click="create()">Создать</b-button></div>
  </div>
</template>
<script>
    import usersList from './users_list'
export default {
  name: 'miniChat',
  components: {
      usersList
  },
  data() {
    return {
        name:'Групповой чат'
    }
  },
  methods: {
      create(){
        this.$http.post('chat/public-room-create?name='+this.name).then(({ data }) => {
         this.$emit('newPublic',this.name,data)
       })
      }
  }
}
</script>

